import { createContext, useEffect } from 'react'
import useItem from '../../../hooks/useItem'
import ListView from './ListView'
import NotListView from './NotListView'
import BidHistory from './BidHistory'
import useIsDesktop from '@utilities/hooks/useIsDesktop'
import classNames from 'classnames'

export const ItemCardManger = createContext({})

const BidItem = ({
  item,
  location,
  bins,
  offers = [],
  options: {
    isListView = false,
    isSavedSearchPage = false,
    isBidsPage = false,
    isWatchlistPage = false,
    cardIndex,
    isSimplified = false,
  },
  handlers: {
    setModalAction,
    setModalData,
    setModalItem,
    setModalType,
    setSelectedItems,
    toggleModal,
    linkMiddleWare,
    deleteItem,
  },
  className = '',
}: any) => {
  const { itemState, setItemState, itemHandler }: any = useItem(item)
  const isDesktop = useIsDesktop()
  const isListViewMiddleware = isDesktop ? isListView : false

  useEffect(() => {
    setItemState((prevState: any) => ({ ...prevState, ...item }))
  }, [item, setItemState])

  const handleSelectItems = (id: number) => {
    if (!setSelectedItems) return
    setSelectedItems((prevState: number[]) =>
      prevState.includes(id)
        ? prevState.filter((prevId) => prevId !== id)
        : [...prevState, id]
    )
  }

  const handleBtnClick = (type: any) => {
    setModalType(type)
    setModalItem(itemState)
    toggleModal(true, 'BinMao')
  }

  return (
    <div className={classNames('h-full', className)}>
      <ItemCardManger.Provider
        value={{
          item: itemState,
          setItem: setItemState,
          itemHandler,
          bins,
          offers,
          location,
          options: {
            isListView: isListViewMiddleware,
            isSavedSearchPage,
            isBidsPage,
            isWatchlistPage,
            cardIndex,
            isSimplified,
          },
          handlers: {
            handleSelectItems,
            handleBtnClick,
            handleDeleteItem: deleteItem,
            toggleModal,
            setModalAction,
            setModalData,
            linkMiddleWare,
          },
        }}
      >
        <div className="relative h-full">
          {itemState.bidHistory.visible && (
            <BidHistory
              bidHistory={itemState.bidHistory.values}
              closeBidHistory={itemHandler.closeBidHistory}
              options={{
                isListViewMiddleware,
                isBidsPage,
                isWatchlistPage,
                cardIndex,
              }}
            />
          )}
          <div className={'hidden sm:block h-full'}>
            {isListViewMiddleware ? <ListView /> : <NotListView />}
          </div>
          <div className={'block sm:hidden h-full'}>
            <NotListView />
          </div>
        </div>
      </ItemCardManger.Provider>
    </div>
  )
}

export default BidItem
